import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Divider,
    Grid,
    Toolbar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TabSettings from './Components/TabsSettings.js';
import TlmBreadcrumbs from '../Components/TlmBreadcrumbs.jsx';
import { Auth } from 'aws-amplify';
import { host } from "../../data";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    text: {
        marginLeft: theme.spacing(10),
    },
}));

export default function TankSettingsPage({ orgInfo, branchInfo, sitesNavDict }) {
    const { t } = useTranslation();
    const classes = useStyles();
    // Get params so we can read the url path parameters
    const params = useParams();
    // Get the site and tank names and site ID.
    const site = params.siteName;
    const siteId = sitesNavDict[site][0];
    const tank = params.tankName === undefined ? null : params.tankName;
    const [tankId, setTankId] = useState(null);
    const [dataReady, setDataReady] = useState(0);
    const baseUrl = '/orgs/' + orgInfo.orgName + '/branches/' + branchInfo.branchName + '/sites/' + site;

    // FETCH Tanks to obtain navDict
    // Create state for the list of sites
    React.useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(data => {
                if (null !== tank) {
                    var body = JSON.stringify({ 'name': tank });
                    var requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': data.signInUserSession.idToken.jwtToken
                        },
                        body: body
                    };
                    console.log("fetch tank id...");
                    fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/lookup', requestOptions)
                        .then(results => results.json())
                        .then(data => {
                            setTankId(data.tankId);
                            setDataReady(1)
                        }).catch((error) => {
                            console.log(error)
                        });
                }
                else { 
                    //New Tank
                    setDataReady(1)
                }
            });
    }, [tank]);

    if (!dataReady) {
        return (<div />);
    }

    return (
        <Grid container
            direction='column'
            justify='flex-start'
            alignItems='stretch'
            className={classes.content}>
            <Grid item xs>
                <Toolbar>
                    {tank === null
                        ? <TlmBreadcrumbs edge='start'
                            orgInfo={orgInfo}
                            branchInfo={branchInfo}
                            site={site}
                            tank={t("addNewTankAndTlm")} />
                        : <TlmBreadcrumbs edge='start'
                            orgInfo={orgInfo}
                            branchInfo={branchInfo}
                            site={site}
                            tank={'Edit '.concat(tank)} />}
                </Toolbar>
            </Grid>
            <Divider />
            <Grid item xs>
                <TabSettings orgInfo={orgInfo}
                    branchInfo={branchInfo}
                    site={site}
                    siteId={siteId}
                    tankId={tankId}
                    setPageDataReady={setDataReady}
                    setTankId={setTankId}
                    baseUrl={baseUrl}
                    tankName={tank} />
            </Grid>
        </Grid>
    )
}
